import m from "../../geodata/es2015/frenchGuianaHigh";
window.am4geodata_frenchGuianaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/frenchGuianaHigh.js
// module id = null
// module chunks = 